import React, { useEffect, useState } from 'react';
import { FormValues } from "./VacancySection";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ApplicationFormProps {
    formData: FormValues;
    title: string;
    closeModal: () => void;
    handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ApplicationForm: React.FC<ApplicationFormProps> = ({
    closeModal,
    handleSubmit,
    handleChange,
    handleFileChange,
    title,
    formData
}) => {
    const [isShowToast, setIsShowToast] = useState<boolean | null>(false);
    const [nameError, setNameError] = useState<string | null>(null);
    const [emailError, setEmailError] = useState<string | null>(null);
    const [mobileError, setMobileError] = useState<string | null>(null);
    const [fileError, setFileError] = useState<string | null>(null);

    const validateForm = () => {
        let isValid = true;
        if (!formData?.name) {
            setIsShowToast(true);
            setNameError('Please enter your name');
            isValid = false;
        } else {
            setNameError(null);
        }
        if (!formData?.email) {
            setIsShowToast(true);
            setEmailError('Please enter your email address');
            isValid = false;
        } else {
            setEmailError(null);
        }
        if (!formData?.mobile) {
            setIsShowToast(true);
            setMobileError('Please enter your mobile number');
            isValid = false;
        } else {
            setMobileError(null);
        }
        if (!formData?.document) {
            setIsShowToast(true);
            setFileError('Please upload your resume');
            isValid = false;
        } else {
            setFileError(null);
        }
        return isValid;
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validateForm()) {
            handleSubmit(e);      
        }
    };
    useEffect(() => {
        if (isShowToast) {
            setTimeout(() => {
                setIsShowToast(false);
            }, 2000)
        }
    }, [isShowToast])

    return (
        <>
        <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        
      />
        <div className='modal-div-content' >
            {/* {isShowToast ? <ToastContainer autoClose={1000} limit={1} /> : null} */}
            <span className="close" onClick={closeModal}>&times;</span>
            <h3 className="mb-5 mil-accent mil-h3">Apply for {title}</h3>
            <form onSubmit={handleFormSubmit}>
                <div className="row">
                    <div className="col-lg-6 service-img">
                        <div className="mil-input-frame mil-dark-input mil-mb-30">
                            <label className="mil-h6 mil-dark">
                                <span>Name</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Your Name"
                                name="name"
                                onChange={(e) => {
                                    handleChange(e);
                                    setNameError(null);
                                }}
                            />
                            {nameError && <span className="text-danger">{nameError}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6 service-img">
                        <div className="mil-input-frame mil-dark-input mil-mb-30">
                            <label className="mil-h6">
                                <span>Email Address</span>
                            </label>
                            <input type="email"
                                placeholder="Enter Your Email Address"
                                name="email"
                                onChange={(e) => {
                                    handleChange(e);
                                    setEmailError(null);
                                }}
                            />
                            {emailError && <span className="text-danger">{emailError}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6 service-img">
                        <div className="mil-input-frame mil-dark-input mil-mb-30">
                            <label className="mil-h6 mil-dark">
                                <span>Mobile No.</span>
                            </label>
                            <input type="tel"
                                placeholder="Enter Your Mobile No"
                                pattern="[0-9]{10,12}"
                                name="mobile"
                                onChange={(e) => {
                                    handleChange(e);
                                    setMobileError(null);
                                }}
                            />
                            {mobileError && <span className="text-danger">{mobileError}</span>}
                        </div>
                    </div>
                    <div className="col-lg-6 service-img">
                        <div className="mil-input-frame mil-dark-input mil-mb-30">
                            <label className="mil-h6">
                                <span>Upload you resume</span>
                            </label>
                            <input
                                type="file"
                                name="document"
                                style={{ paddingTop: 15, color: 'grey' }}
                                onChange={(e) => {
                                    handleFileChange(e);
                                    setFileError(null);
                                }}
                                accept=".pdf,.doc,.docx"
                            />
                            {fileError && <span className="text-danger">{fileError}</span>}
                        </div>
                    </div>
                    {/* set the button in center by padding */}
                    <div className="col-lg-3 service-img d-flex justify-content-center align-items-center w-100">
                        <button className=' px-5 mil-button mil-border' type='submit'>
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
        </>
    );
};



export default ApplicationForm;
